import {
	PaymentMethodApi,
	PaymentMethodSetting,
	PaymentMethodSettingApi,
} from "../../../../../../../../../services/Api/Organization/types";

export const getPaymentMethodOnlinePayments = () => {
	return [
		PaymentMethodSetting.BLIK_OFFLINE_ENABLED,
		PaymentMethodSetting.BLIK_ONLINE_ENABLED,
		PaymentMethodSetting.E_TRANSFER_ENABLED,
		PaymentMethodSetting.APPLE_PAY_ENABLED,
		PaymentMethodSetting.GOOGLE_PAY_ENABLED,
		PaymentMethodSetting.PAYMENT_CARD_ENABLED,
	];
};

export const getParsedPaymentMethodSettingsToDefaultValues = (
	paymentMethod?: PaymentMethodApi,
	paymentMethodSettings?: PaymentMethodSettingApi[]
) => {
	const onlinePaymentMethods = getPaymentMethodOnlinePayments();
	const parsedSettings = (paymentMethod ? paymentMethod.settings || [] : paymentMethodSettings || []).map(
		(setting) => {
			if (typeof setting.value === "string" && (setting.value === "false" || setting.value === "true")) {
				return {
					...setting,
					value: setting.value === "true",
				};
			}
			return setting;
		}
	);
	const restOfPaymentsSettings = parsedSettings.filter((setting) => !onlinePaymentMethods.includes(setting.name));

	if (!paymentMethod) {
		if (restOfPaymentsSettings.length === 0) {
			restOfPaymentsSettings.push({ name: PaymentMethodSetting.SECRET_TPAY_CLIENT_ID, value: "" });
			restOfPaymentsSettings.push({ name: PaymentMethodSetting.SECRET_TPAY_CLIENT_SECRET, value: "" });
		}

		return [
			...restOfPaymentsSettings,
			...onlinePaymentMethods.map((onlinePaymentMethod) => ({
				name: onlinePaymentMethod,
				value: false,
			})),
		];
	}

	const onlinePaymentsSettings: PaymentMethodSettingApi[] = onlinePaymentMethods.map((onlinePaymentMethod) => {
		const parsedSetting = parsedSettings.find((setting) => setting.name === onlinePaymentMethod);

		return (
			parsedSetting ?? {
				name: onlinePaymentMethod,
				value: false,
			}
		);
	});

	const sortedPaymentsSettings = onlinePaymentsSettings.sort((a, b) => {
		const indexA = onlinePaymentMethods.indexOf(a.name);
		const indexB = onlinePaymentMethods.indexOf(b.name);
		return indexA - indexB;
	});

	return [...sortedPaymentsSettings, ...restOfPaymentsSettings];
};

export const getDefaultPaymentMethodValues = (
	paymentMethod?: PaymentMethodApi,
	paymentMethodSettings?: PaymentMethodSettingApi[]
) => {
	const settings = getParsedPaymentMethodSettingsToDefaultValues(paymentMethod, paymentMethodSettings);

	if (paymentMethod) {
		return {
			...paymentMethod,
			settings,
		};
	}

	return {
		outflow_type: "WZ",
		receipt_type: "CARD",
		print_receipt: true,
		settings,
	};
};
